// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"261":"assets/css/style","462":"assets/css/answer","547":"assets/css/question-paper","875":"assets/css/page"}[chunkId] + ".css";
};